import React from 'react';
import RubikaLogo from '../../components/icons/RubikaLogo';
import {
  FiActivity,
  FiEdit2,
  FiFolder,
  FiLayers,
  FiLock,
  FiLogOut,
  FiMenu,
  FiMessageCircle,
  FiPlusSquare,
  FiSend,
  FiSettings,
  FiShoppingCart,
  FiTrash2,
  FiTag,
  FiUsers,
  FiX,
} from 'react-icons/fi';

const ICON_MAP = {
  plusSquare: FiPlusSquare,
  edit: FiEdit2,
  layers: FiLayers,
  comment: FiUsers,
  differentItems: FiFolder,
  trash: FiTrash2,
  cart: FiShoppingCart,
  direct: FiSend,
  setting: FiSettings,
  whatsapp: FiMessageCircle,
  lockKeyhole: FiLock,
  lockOpen: FiLogOut,
  activity: FiActivity,
  version: FiTag,
  menu: FiMenu,
  close: FiX,
};

export function AdminNavIcon({ name, size = 20, className, title }) {
  if (name === 'rubika') {
    return (
      <RubikaLogo width={size} height={size} className={className} alt={title || 'روبیکا'} style={{ display: 'block' }} />
    );
  }

  const Icon = ICON_MAP[name] || FiSettings;

  return <Icon size={size} className={className} aria-hidden={title ? undefined : true} title={title} />;
}
